import { render, staticRenderFns } from "./vaccinecard.vue?vue&type=template&id=993882d4&scoped=true&"
import script from "./vaccinecard.vue?vue&type=script&lang=js&"
export * from "./vaccinecard.vue?vue&type=script&lang=js&"
import style0 from "./vaccinecard.vue?vue&type=style&index=0&id=993882d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993882d4",
  null
  
)

export default component.exports